import React, { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

export function SceneCamera({ fov, height, allowPositionOverride = true, spawnPoint = null }) {
    const { camera } = useThree();

    useEffect(() => {
        console.log('Player camera initialized:', camera);
        // Set initial position for the camera using spawn point if provided
        if (allowPositionOverride) {
            if (spawnPoint?.cameraPosition && spawnPoint?.cameraLookAt) {
                // Use spawn point camera settings
                const [x, y, z] = spawnPoint.cameraPosition;
                const [lx, ly, lz] = spawnPoint.cameraLookAt;
                camera.position.set(x, y, z);
                camera.lookAt(lx, ly, lz);
                console.log('🎯 DEBUG: Using spawn point camera position:', spawnPoint.cameraPosition);
                console.log('🎯 DEBUG: Full spawn point data:', spawnPoint);
            } else {
                // Fall back to default positioning
                camera.position.set(0, height, 15); // Back and elevated for a good overview
                camera.lookAt(0, 0, 0); // Look at the center of the scene
                console.log('🎯 DEBUG: Using fallback camera position');
            }
        }
        camera.fov = fov;
        camera.updateProjectionMatrix();
    }, [fov, height, camera, allowPositionOverride, spawnPoint]);

    return null;
} 